import { HttpErrorResponse } from '@angular/common/http';
import {
  PaymentAccountBurnVerified,
  PreAuthorizedDebitMode,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PoiPadResultComponentPadActions = createActionGroup({
  source: 'Pad Result Component Pad',
  events: {
    'Complete Twikey Invite Success': emptyProps(),
    'Complete Twikey Invite Error': props<{
      error?: HttpErrorResponse;
      message?: string;
    }>(),
    'Load Pre Authorized Debit Mode Success': props<{
      payload: PreAuthorizedDebitMode;
    }>(),
    'Load Pre Authorized Debit Mode Error': props<{
      error: HttpErrorResponse;
    }>(),
    'Pad Verification Success': props<{
      payload: PaymentAccountBurnVerified[];
    }>(),
    'Pad Verification Error': props<{
      error: HttpErrorResponse;
    }>(),
  },
});
